/**溯源码路由 */
export default [
    {
        name: 'code',
        path: 'code',
        meta: { title: '溯源码管理' },
        component: () => import('@/pages/index.vue'),
        children: [
            {
                name: 'code-info',
                path: 'info',
                meta: { title: '溯源码信息' },
                component: () => import('@/pages/code/info.vue'),
            },
            {
                name: 'code-add',
                path: 'add',
                meta: { title: '批量生成溯源码' },
                component: () => import('@/pages/code/add.vue')
            },
            {
                name: 'code-edit',
                path: 'edit',
                meta: { title: '批量修改溯源码' },
                component: () => import('@/pages/code/edit.vue')
            },
            {
                name: 'code-recycle',
                path: 'recycle',
                meta: { title: '溯源码回收站' },
                component: () => import('@/pages/code/recycle.vue')
            },
        ]
    }
]